"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FaqLayout = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useTranslations = require("../../hooks/useTranslations");
var _utils = require("../../utils");
var _styles = require("../HeadlineLayout/styles");
var _constants = require("./constants");
var _mapGqlDataToAccordion = require("./mapGqlDataToAccordion");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FaqLayout = (param)=>{
    let { data, modulePosition, debug, className } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations } = (0, _useTranslations.useTranslations)();
    const parsedQuestionsToAccordion = (0, _react.useMemo)(()=>(0, _mapGqlDataToAccordion.mapGqlDataToAccordion)(data === null || data === void 0 ? void 0 : data.questions), [
        data === null || data === void 0 ? void 0 : data.questions
    ]);
    if (!parsedQuestionsToAccordion || parsedQuestionsToAccordion.length < 1) {
        return (0, _utils.getModulesContentError)({
            debug,
            modulePosition,
            layout: _constants.FAQ_MODULE_NAME
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles2.Root, {
        className: className,
        "data-testid": getTestId(_constants.FAQ_LAYOUT),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Headline, {
                "data-testid": getTestId(_constants.FAQ_LAYOUT_TITLE),
                textAlign: "center",
                variant: "h4",
                component: "h2",
                children: translations.faq
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.Accordions, {
                items: parsedQuestionsToAccordion
            })
        ]
    });
};
exports.FaqLayout = FaqLayout;
